module.exports = __webpack_public_path__ + "static/media/KOSTRAS_MENU-normal.73a53efd.png";